export default __webpack_public_path__ + "static/black-b4cd5c63ecd2b6c5e52c9bb85714e57f.svg";